import ModelKeyRepository from '../repositories/ImmutableRepository';
import KeyModifier from '../repositories/modifier/ExpandKeyModifier';
var preMatchRepository = new ModelKeyRepository();
var menuRepository = new ModelKeyRepository();
var liveRepository = new ModelKeyRepository();
var liveMatchRepository = new ModelKeyRepository();
var popularMatchesRepository = new ModelKeyRepository();
var timetableRepository = new ModelKeyRepository();
var highlightsRepository = new ModelKeyRepository();
var bannersRepository = new ModelKeyRepository();
var resultsRepository = new ModelKeyRepository();
export var TRANSFORM = Symbol('Transform');
function transformData(data, transformType, section) {
    var repo;
    var modifier;
    if (section === 'preMatch') {
        repo = preMatchRepository;
    }
    else if (section === 'preMatchEvent') {
        repo = preMatchRepository;
    }
    else if (section === 'live') {
        repo = liveRepository;
    }
    else if (section === 'liveMatch') {
        repo = liveMatchRepository;
    }
    else if (section === 'menu') {
        repo = menuRepository;
    }
    else if (section === 'popularMatches') {
        repo = popularMatchesRepository;
    }
    else if (section === 'timetable') {
        repo = timetableRepository;
    }
    else if (section === 'highlights') {
        repo = highlightsRepository;
    }
    else if (section === 'banners') {
        repo = bannersRepository;
    }
    else if (section === 'results') {
        repo = resultsRepository;
    }
    if (!repo) {
        return data;
    }
    if (transformType === 'init' || transformType === 'update') {
        modifier = new KeyModifier(repo);
    }
    if (modifier) {
        modifier.modify(data);
    }
    return data;
}
export default (function (store) { return function (next) { return function (action) {
    var transform = action[TRANSFORM];
    if (typeof transform === 'undefined') {
        return next(action);
    }
    var transformType = transform.transformType, section = transform.section, provider = transform.provider;
    var type = action.type;
    var data = action.data;
    var content;
    if (typeof provider === 'function') {
        content = provider(data);
    }
    if (!content) {
        return next(action);
    }
    function actionWith(data) {
        var finalAction = Object.assign({}, action, data);
        delete finalAction[TRANSFORM];
        return finalAction;
    }
    var transformedData = transformData(content, transformType, section);
    return next(actionWith({
        type: type,
        data: transformedData,
        section: section
    }));
}; }; });



// WEBPACK FOOTER //
// ./src/middleware/transform.js